import { IPluginMetadataSucceededResult } from 'app/apis/plugin-metadata-api.service';

import { format } from 'app/shared/utils/string.util';

const connector: IPluginMetadataSucceededResult = {
    connectorName: 'Dataworld',
    dataType: 'Hierarchical',
    SupportEncryption: true,
    connectionSettings: [
        {
            type: 'String',
            name: 'apiToken',
            required: true,
            sensitive: true,
            signature: false
        }
    ],
    readSettings: [
        {
            type: 'String',
            name: 'owner'
        },
        {
            type: 'String',
            name: 'datasetId',
            displayName: stringResources.Dataset_nameLabel,
            required: true
        },
        {
            type: 'String',
            name: 'tableId',
            displayName: stringResources.Table_name_Label
        },
        {
            type: 'String',
            name: 'query'
        }
    ],
    writeSettings: [],
    adfAppModelConfiguration: {
        displayName: format(stringResources.ModelName_DisplayTextPreviewTemplate, 'data.world'),
        icon: {
            className: 'svg-i-100x100-dataWorld'
        },
        category: ['ServicesApps'],
        linkedService: {
            properties: [
                'apiToken'
            ],
            uiControls: [
                {
                    bind: 'apiToken',
                    controlType: 'TextBox',
                    displayName: stringResources.ModelName_Token
                }
            ]
        },
        dataflowInlineSource: {
            properties: [
                'owner',
                'datasetId',
                'tableId',
                'query'
            ],
            uiControls: [
                {
                    bind: 'owner',
                    controlType: 'TextBox',
                    displayName: stringResources.PreserveRules_Owner_Label,
                    required: true
                },
                {
                    bind: {
                        schema: 'datasetId',
                        table: 'tableId'
                    },
                    controlType: 'SchemaTableSelection',
                    controlSettings: {
                        browseSettings: {
                            includedSettingsKeys: ['owner'],
                            tableKey: 'tables',
                            schemaLabelKey: 'id',
                            schemaValueKey: 'id',
                            tableLabelKey: 'tableId',
                            tableValueKey: 'tableId'
                        }
                    }
                },
                {
                    bind: 'query',
                    controlType: 'TextArea',
                    displayName: stringResources.QueryLabel
                }
            ],
            itemSettings: {
                dataflowType: 'dataworld',
                dataflowFormat: 'rest',
                dataflowUseInlineProjection: true
            }
        }
    }
};

export default connector;
